import React, { Component, Fragment } from 'react';
import Button from '../../../components/atoms/Button';
import DataDiri from './DataDiri';
import DataPerusahaan from './DataPerusahaan';
import DokumenPerusahaan from './DokumenPerusahaan';
import DataRekening from './DataRekening';
import DataKeuangan from './DataKeuangan';

export default ({ statusBtn, changeBtn, dataDetail, setFromParam }) => {
  // console.log('====================================');
  // console.log({ dataDetail });
  // console.log('====================================');
  return(
    <div>
      <div className='bg-vertical-scroll bg-button-vertical'>
        {
          statusBtn.map(( value, index ) => {
            return(
              <Fragment key={index}>
                {
                  value.status ? (
                    <Button title={value.title} type={'button'} color="yellow" width="small-rounded" onClick={()=>changeBtn(index)} />
                  ) : (
                    <Button title={value.title} type={'button'} color="yellow" width="small-rounded outline" onClick={()=>changeBtn(index)} />
                  )
                }
              </Fragment>
            )
          })
        }
      </div>
      <div className='card-data-pinjaman'>
        {
					statusBtn.map(( value, index ) => {
						if(value.status){
							if(value.key === 'DataDiri'){
                return <DataDiri key = {index} title={ value.title } dataDetail={dataDetail.picDetail} setFromParam={setFromParam}/>
              } 
              else if(value.key === 'DataPerusahaan'){
								return <DataPerusahaan key = {index} title={ value.title } dataDetail={dataDetail} setFromParam={setFromParam}/>
              } 
              else if(value.key === 'DokumenPerusahaan'){
								return <DokumenPerusahaan key = {index} title={ value.title } dataDetail={dataDetail.customerInfo.corporate.documents} />
              } 
              else if(value.key === 'DataRekening'){
								return <DataRekening key = {index} title={ value.title } dataDetail={dataDetail.bankAccountInfo}/>
              } 
              else if(value.key === 'DataKeuangan'){
								return <DataKeuangan key = {index} title={ value.title } infoDocs={dataDetail.customerInfo.corporate.documents} />
              }
						}
					})
				}
      </div>
    </div>
  )
}